<div class="popup-wrapper"
  (ssOnSelect)="onSelectWrapper($event)">

  <div class="popup-container">
    <div #popupContent
      class="popup-content">

      <a (click)="closePopup($event)"
        class="popup-close-icon">
          <i class="far fa-times"></i>
      </a>

      <ng-content></ng-content>
    </div>
  </div>
</div>

